




import { Component, Vue } from "vue-property-decorator";

/**
 * Shown on a phone (< 600 px) where an IRES Admin Client screen is for authoring, in place of its edit
 * actions: the Beschreibung editor, PDF template editing, the RENO review stepper and the Neuer Mandant
 * setup (Taimoor, 2026-11-03). Those need room a phone does not have (wide tables, a PDF beside its
 * fields, a drying graph), so a phone may view them but not edit; quick decisions elsewhere stay open.
 */
@Component
export default class PhoneEditingHintComponent extends Vue {}
